import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { DataConfirm } from './confirm.service';

@Component({
    selector: 'confirm',
    styleUrls: ['./confirm.component.scss'],
    template: `
    <mat-card>
      <h1 matDialogTitle class="mb-8">{{ data.title }}</h1>
      <div mat-dialog-content class="mb-16">
        <p [innerHTML]="data.message"></p>
      </div>
      @if (data?.buttonCancel?.show || data?.buttonConfirm?.show) {
        <div mat-dialog-actions class="pb-4">
          <div class="dialog-actions-row">
            <div class="action-item">
              @if (data?.buttonConfirm?.show) {
                <button
                  [class.maria]="data.theme === 'maria'"
                  mat-flat-button
                  type="submit"
                  color="primary"
                  (click)="dialogRef.close(true)"
                  class="w-full ml-none"
                  >
                  {{ data?.buttonConfirm?.label }}
                </button>
              }
            </div>
            @if (data?.buttonCancel?.show) {
              <div class="action-item">
                <button
                  [class.maria]="data.theme === 'maria'"
                  mat-dialog-close
                  color="accent"
                  mat-raised-button
                  type="button"
                  (click)="dialogRef.close(false)"
                  class="w-full"
                  >
                  {{ data?.buttonCancel?.label }}
                </button>
              </div>
            }
          </div>
        </div>
      }
    </mat-card>
    `,
    standalone: false
})
export class ConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataConfirm,
  ) {
  }
}
